import React, {useRef} from "react"
import { StaticQuery, graphql, navigate } from "gatsby"
import DLIcon from "../svg/DLIcon"
import CloseX from "../svg/CloseX"
import { FiDownload } from 'react-icons/fi';
import { FiX } from 'react-icons/fi'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
//import { faArrowToBottom } from '@fortawesome/pro-light-svg-icons';
import { faFilePdf } from '@fortawesome/pro-light-svg-icons';
import gsap, { TweenMax, TimelineMax } from "gsap";
// import PDF1 from "../../images/PJM_2019_Financials_Individual.pdf"
// import PDF2 from "../../images/PJM_2019_Financials_Individual.pdf"
import { Link } from "gatsby";


const Header = ({ data, slideView, toggleView, appWidth, appHeight }) => {
  let mobileChecker = appWidth < 642 || (appHeight < 600 && appWidth < 642) || ((appHeight / appWidth < .7) && appHeight < 600);
  
  const headerRef = useRef();
  let slideClass;
  if (slideView) {
    slideClass = "single" 
  } else {
    slideClass = "hero"
  }
  
  const navAnimation = () => {
    toggleView();
    const tl = new TimelineMax();
    const body = document.body;
    
    tl.to(body, .25, {opacity: 0.2})
    .to(body, .25, {opacity: 1})

    if(mobileChecker) {
      navigate('/mobile');
    }
  }
  return (
    <header
      ref={headerRef}
      className={slideView ? "single" : "hero"}
    >
      <div id="page-header" className={slideClass === "single" ? "single-header" : "main-header"} >
        <div className="logo-container">
        <Link to="/">
          <h1 className="logo">
            <span className="logo-top">PJM 2019 Annual Report</span>
            <span className="logo-1"><span className="magenta">RE</span><span className="ltblue">FLECT. </span></span>
            <span className="logo-2"><span className="midblue">RE</span><span className="green">FOCUS. </span></span>
            <span className="logo-3"><span className="yellow">RE</span><span className="magenta">FINE.</span></span>
          </h1>
          </Link>
        </div>
        <div className="header-links">
          <a href="https://pjm.com/~/media/about-pjm/newsroom/annual-reports/2019-financials.ashx" target="_blank">
            <span className="desktop">
				Financial Report
				<span className="dlIcon">
				<FiDownload />
				</span>
	  		</span>
	         <span className="mobile">
				
				<span className="dlIcon">
				<FontAwesomeIcon icon={faFilePdf} />
				</span>
	  			10K
	  		</span>
          </a>
          <a href="https://www.pjm.com/-/media/about-pjm/newsroom/annual-reports/2019-annual-report.ashx" target="_blank">
            <span className="desktop">
	  			Editorial Report
            	<span className="dlIcon">
	  				<FiDownload/>
	  			</span>
	  		</span>
	  		<span className="mobile">
				
				<span className="dlIcon">
					<FontAwesomeIcon icon={faFilePdf} />
				</span>
	  			Editorial
	  		</span>
          </a>
	  
        </div>
        <div className="header-close-button">
          <button onClick={navAnimation}>
            <FiX className="headerClose" />
          </button>
        </div>
      </div>
    </header>
  )
}

export default props => (
  <StaticQuery
    query={graphql`
      query HeadingQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
    render={data => <Header data={data} {...props} />}
  />
)
